(function () {
  const confirm = document.getElementById("cookie-confirm-button");
  const GDPR_block = document.querySelector(".gdpr-banner--root");
  const consentCookie = Boolean(getCookie(COOKIE_POLICY_NAME));
  if (GDPR_block && !consentCookie) {
    GDPR_block.style.display = "block";
  }
  if (confirm && GDPR_block && !consentCookie) {
    confirm.addEventListener("click", (e) => {
      setCookie(COOKIE_POLICY_NAME, "dismiss", 365);
      GDPR_block.style.display = "none";
    });
  }
})();
